import { Wrapper } from '@american-autonomy/ag-ui';

import SingleSelectPanel from 'components/SingleSelectPanel';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Item, Props } from './types';

import styles from './styles.module.scss';

const UnitSelectPanelField: FunctionComponent<Props> = ({
    assetId,
    className = '',
    onChange,
    onClose,
    partType,
    testId = TEST_ID,
    value
}) => {
    const { SEARCH } = useTranslation();
    const { isLoading, noItemsText, unitItems } = useData({ assetId, partType });

    const handleClick = (unit: Item) => {
        onChange(unit);
        onClose?.(unit);
    };

    return (
        <Wrapper className={className} testId={testId}>
            <SingleSelectPanel
                className={styles.selectPanel}
                isLoading={isLoading}
                isSearchable={false}
                itemSelected={value}
                items={unitItems}
                label={SEARCH}
                noItemsFoundText={noItemsText}
                onSelected={handleClick}
            />
        </Wrapper>
    );
};

export default UnitSelectPanelField;
